module.exports = __webpack_public_path__ + "static/unakite-rock-439d54aa591b7fa3252ea5258e065434.jpg";